
export const _70z = { // メール送信
  _70r: {
    v0: {
      itlz: {
        _70r_31r1f: -1,
        _icn: '',
        _pfx: '',
        _70r_10r1k: -1,
        _70rd1100s: '',
        _70rs1100i: -1,
        _70ra1100j: '',
        _70ra2100t: '',
      },
      fldz: {
        _70r_31r1f: {
          pfx: '部門'
        },
        _icn: {
          pfx: 'メールID',
          atrs: [
            {
              qry: `
                UPDATE
                  _70rs
                SET
                  _icn = (
                    SELECT
                      to_char(COUNT(A.*), 'fm000000000')
                    FROM
                      _70rs AS A
                    WHERE
                      COALESCE(A._dlt,-1) <> 1 AND A._dmn = _70rs._dmn AND A._vsn = A._ltt
                      AND A._key <= _70rs._key
                  )
                WHERE
                  _key = {_70r_key}
                `,
              rlcz: {
                _70r_key: '_70rs._key',
              }
            }
          ],
        },
        _pfx: {
          pfx: '件名'
        },
        _70r_10r1k: { // _fst でなく _key
          pfx: '送信者'
        },
        _70rd1100s: {
          pfx: '送信日時'
        },
        _70rs1100i: {
          pfx: '送信状況',
          ls: [
            { key: -1, pfx: '未送信' },
            { key:  1, pfx: '送信済' },
          ]
        },
        _70ra1100j: {
          pfx: '宛先'
        },
        _70ra2100t: {
          pfx: '内容'
        },
      },
    },
  },
};
